export default __webpack_public_path__ + "static/media/new-close-icon.fd3c042a.svg";